import React, { lazy } from 'react';
import { dashboardMenu, demoPages } from '../menu';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import VerificationOTP from '../pages/auth/VerifyOTP';
import SubscriptionPlan from '../pages/subscription/SubscriptionPage';
import PublishPost from '../pages/publish-post/PublishPost';
import SchedulePost from '../pages/schedule-post/SchedulePost';
import Profile from '../pages/profile/Profile';
import PostHistory from '../pages/post-history/PostHistory';

const LANDING = {
    DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
};

const AUTH = {
    PAGE_404: lazy(() => import('../pages/auth/Page404')),
};

const presentation = [
    /* DASHBOARD START */
    {
        path: dashboardMenu.dashboard.path,
        element: <LANDING.DASHBOARD />,
        exact: true,
    },
    /* DASHBOARD END */

    /* AUTH PAGES START */
    {
        path: '/404',
        element: <AUTH.PAGE_404 />,
        exact: true,
    },
    {
        path: '/login',
        element: <Login />,
        exact: true,
    },
    {
        path: '/register',
        element: <Register />,
        exact: true,
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />,
        exact: true,
    },
    {
        path: '/verify',
        element: <VerificationOTP />,
        exact: true,
    },
    /* AUTH PAGES END */

    /* SUBSCRIPTION PLAN START */
    {
        path: demoPages.pricingTable.path,
        element: <SubscriptionPlan />,
        exact: true,
    },

    /* PUBLISH POST START */
    {
        path: demoPages.publishPost.path,
        element: <PublishPost />,
        exact: true,
    },

    /* SCHEDULE POST START */
    {
        path: demoPages.schedulePost.path,
        element: <SchedulePost />,
        exact: true,
    },

    /* POST HISTORY START */
    {
        path: demoPages.postHistory.path,
        element: <PostHistory />,
        exact: true,
    },

    /* PROFILE START */
    {
        path: '/profile',
        element: <Profile />,
        exact: true,
    },
];
const contents = [...presentation];

export default contents;
